<template>
    <div>
        Unknow row component : {{row.type}}
    </div>
</template>


<script>

    export default {

        props: {
            row: {
                type: Object,
                default: () => {}
            }
        }

    }
</script>